import { getSelectBoxOptionsFromConstants } from "../utils/commonUtils"
import SkillLevel from "./SkillLevel"
import TopicOptions from "./TopicOptions"
import SkillLevelArticle from "./SkillLevelArticle"
export const SkillLevelOptions = getSelectBoxOptionsFromConstants(SkillLevel)
export const TopicOptionsList = getSelectBoxOptionsFromConstants(TopicOptions)
export const SkillLevelArticleOptions = getSelectBoxOptionsFromConstants(SkillLevelArticle)
